export const validateUrl = (str) => {
  if (!str || typeof str !== "string") return false;
  const s = str.trim();
  if (!/^https?:\/\//i.test(s)) return false;
  try {
    // validation host/path
    // eslint-disable-next-line no-new
    new URL(s);
    return true;
  } catch {
    return false;
  }
};
